import { createTheme } from "@mui/material";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";

export const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          background: "transparent",
          fontFamily:
            '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          "& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]":
            {
              background: "inherit !important",
            },
        },
        columnHeaders: {
          background: "#f5f6fa",
          borderBottom: "1px solid #e8eaf0",
          borderRadius: 0,
          minHeight: "52px !important",
          maxHeight: "52px !important",
        },
        columnHeader: {
          padding: "0 18px",
          "&:focus, &:focus-within": { outline: "none" },
        },
        columnHeaderTitle: {
          color: "#9ca3af",
          fontWeight: 600,
          fontSize: "0.72rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        },
        columnSeparator: { display: "none" },
        cell: {
          borderBottom: "1px solid #e8eaf0",
          color: "#171717",
          fontSize: "0.88rem",
          padding: "0 18px",
          display: "flex",
          alignItems: "center",
          "&:focus, &:focus-within": { outline: "none" },
        },
        row: {
          transition: "background-color 120ms ease",
          "&:hover": {
            backgroundColor: "#f8fafc",
          },
          "&:last-of-type .MuiDataGrid-cell": { borderBottom: 0 },
        },
        footerContainer: {
          borderTop: "1px solid #e8eaf0",
          minHeight: "52px !important",
        },
        virtualScroller: { background: "#ffffff" },
      },
    },
  },
});

export function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ p: 1.5 }}>
      <GridToolbarQuickFilter
        debounceMs={500}
        sx={{
          "& .MuiInput-root": {
            borderRadius: "10px",
            border: "1px solid #e8eaf0",
            padding: "6px 12px",
            "&:before, &:after": { display: "none" },
            background: "#fff",
          },
          "& .MuiInput-input": {
            fontSize: "0.9rem",
          },
        }}
      />
    </GridToolbarContainer>
  );
}
